/**
 * Which app owns a path. Core's router in main.ts mounts the Vue game app
 * for /play/* and the landing site for the public pages, then leaves
 * navigation inside each to its own vue-router.
 */
export const GAME_PREFIX = '/play';

export function isGameRoute(pathname: string): boolean {
  return pathname === GAME_PREFIX || pathname.startsWith(`${GAME_PREFIX}/`);
}

/** The public landing site: home, news (list and articles), FAQ, legal pages. */
export function isLandingRoute(pathname: string): boolean {
  return pathname === '/' || /^\/(news|faq)\/?$/i.test(pathname) || /^\/(news|legal)\/[a-z0-9-]+\/?$/i.test(pathname);
}
